export const GET_PRODUCT = 'providers/menuMaker/ProductDetails/GET_PRODUCT';
export const EDIT_PRODUCT = 'providers/menuMaker/ProductDetails/EDIT_PRODUCT';
export const UPDATE_PRODUCT_PRICE = 'providers/menuMaker/ProductDetails/UPDATE_PRODUCT_PRICE';
